import React, { useEffect, useState } from "react";
import "./All_Product.css";
import Product_card from "../../common-components/product_card/Product_card";
import Filter_btn from "../../common-components/common_btn/filter_btn/Filter_btn";
import {
  faBarsStaggered,
  faFilter,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "./filter_offcanvas/Filter_offcanvas";
import Sort_offcanvas from "./sort_offcanvas/Sort_offcanvas";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../features/products/productsSlice";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function All_Product({
  filters,
  selectId,
  categoryName,
  subCategoryId,
  sortOrder,
  setSortOrder,
  allProducts,
  handleShow,
  handleClose,
  handleApplyFilters,
  handleClearFilters,
  handleCloseSort,
  handleShowSort
}) {
  const { id } = useParams();

  
  

  
  
  // const [sortOrder, setSortOrder] = useState();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const dispatch = useDispatch();

  // const hasStock = (product) => {
  //   if (Number(product?.stock || 0) > 0) return true;

  //   return (
  //     product?.Product_Variants?.some((variant) => {
  //       if (Number(variant?.general_stock || 0) > 0) return true;

  //       return variant?.Double_Variants?.some((doubleVar) => {
  //         if (Number(doubleVar?.stock || 0) > 0) return true;

  //         return doubleVar?.Triple_Variants?.some(
  //           (tripleVar) => Number(tripleVar?.stock || 0) > 0,
  //         );
  //       });
  //     }) || false
  //   );
  // };

  return (
    <>
      <section className="All_Product">
        <div className="container-fluid">
          <div className="mobile_filter_btn">
            <button onClick={handleShow} className="filter_btn">
              <FontAwesomeIcon icon={faFilter} style={{ color: "#840101" }} />{" "}
              <span>Filters</span>
            </button>

            <button onClick={handleShowSort} className="filter_btn ms-2">
              <FontAwesomeIcon icon={faSort} style={{ color: "#840101" }} />{" "}
              <span>Sort</span>
            </button>
          </div>

          {/* <div className="filter_holder">
            <div className="filter_btn_holder">
              <Filter_btn
                btnText="Sort"
                icon={faBarsStaggered}
                onClick={handleShowSort}
              />
            </div>
          </div> */}
          <div className="">
            <div className="all_prods_holder">
              {allProducts && allProducts?.length > 0 ? (
                <div className="row">
                  {allProducts?.map((product, index) => (
                    <div
                      className="col-lg-3 col-md-4 col-6 px-md-2 px-1 custom_5_col"
                      key={index}
                    >
                      <div className="product_card_holder">
                        <Product_Info_Card
                          id={product?.id}
                          product={product}
                          imgSrc={
                            product?.image && product?.image !== ""
                              ? product?.image
                              : "/assets/images/common alex jewellery.png"
                          }
                          productName={product?.name}
                          prodDiscount={product?.prod_discount}
                          productDesignId={product?.design_id}
                          priceText={product?.Product_Variants?.[0]?.price || 0}
                          mrp={product?.Product_Variants?.[0]?.mrp || 0}
                          // kgText={product?.Brand?.name || ""}
                          savingPrice={
                            parseFloat(
                              product?.Product_Variants?.[0].mrp || 0,
                            ) -
                            parseFloat(
                              product?.Product_Variants?.[0].price || 0,
                            )
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no_product_available_holder text-center w-100">
                  <h3>No Product Available</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      
     
    </>
  );
}

export default All_Product;
